import { combineReducers, Reducer } from "redux";
import { sendToPartnerReducer } from "./send-to-partner/reducer";
import { ISoftwareState } from "./types";

const reducer: Reducer<ISoftwareState> = combineReducers<ISoftwareState>({ sendToPartner: sendToPartnerReducer });

export { reducer as softwareReducer };
